export { addEllipsis } from "./addEllipsis";
